<template>
    <v-card>
      <v-card-title class="headline"></v-card-title>
      <v-card-text>Seems that we didn't find the supplier or customer of this invoice. Please fill this information: </v-card-text>
      <v-card-text>Is this a invoice from a supplier or from a customer? <v-select v-model="type" :items="['Supplier', 'Customer']"></v-select></v-card-text>
      <v-card-text v-if="type">Wich one? <v-autocomplete v-model="company" :items="suppliers" item-text="name"
                  item-value="id"></v-autocomplete></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" :disabled="!type || !company" text @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'FixSuppCostNotFound',
  components:{
  },
  props: {
    
  },
  computed:{
    ...mapActions({ saveLabels: "documents/saveLabels" }),
    ...mapState(['suppliers']),
    ...mapGetters({
      currentDoc: "documents/currentDocument"
    })
  },
  methods:{
    save() {
      // FIXME: This tries to moutate store directly
      this.currentDoc.state = 'pending'
      // FIXME: This tries to moutate store directly
      this.currentDoc.supplier = this.company;
      this.saveLabels(true)
    }
  
  },
  data() {
    return {
      type:'',
      company:{},
    }
  }
}
</script>

